import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { setPortal } from 'modules/portal';
import { KeywordStatistics } from 'lib/api/keywordcenter';
import {
  makeRowColumn,
  getHeadObj,
  converParameters,
  converDisplayValue,
  getHost,
} from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const Statistics = (props) => {
  const { t } = useTranslation();
  const { type, location } = props;
  const dispatch = useDispatch();

  const { common, portal } = useSelector(({ common, portal }) => ({
    portal: portal,
    common: common,
  }));

  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().add(-1, 'day').format('YYYYMMDD'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    type: type,
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const initCustomized = {
    ADVER_IDS: { merged: true },
    ECPM: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ECPM');
        return makeRowColumn(
          rowObj['ECPM'],
          bodyItem1.type,
          params.type === 'kwrdNm' ? bodyItem1.format + '.#' : bodyItem1.format
        );
      },
    },
  };
  const [customized, setCustomized] = useState(initCustomized);

  useEffect(() => {
    handleCustom(initParams);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handleCustom = (newParams = params) => {
    let newCustomized = { ...initCustomized };
    newCustomized['ADVER_CNT'] = {
      makeBody: (rowObj, headsMap) => {
        const itemObj = getHeadObj(headsMap, 'ADVER_CNT');
        const showWindowUrl = converParameters({
          url: getHost() + '/v2/popup/manage_report_adver_new.php',
          // url: 'https://stage4.mobon.net/v2/popup/manage_report_adver_new.php',
          gb: converDisplayValue(
            common.productCodeList,
            newParams['advrtsPrdtCode'],
            newParams['advrtsTpCode']
          ),
          st_date: moment(newParams.sDate).format('YYYY-MM-DD'),
          en_date: moment(newParams.eDate).format('YYYY-MM-DD'),
          kwrdNo: rowObj['KWRD_SEQ'],
          isPop: 1,
          baseAddress: location.pathname,
        });
        return (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['ADVER_CNT'],
              itemObj.type,
              itemObj.format
            )}
            icon={'faExternalLink'}
            toolTipTitle={t('해당 키워드의 광고주 통계')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
    };
    newCustomized['ORDER_CNT'] = {
      makeBody: (rowObj) => {
        const showWindowUrl = converParameters({
          url: getHost() + '/v2/popup/daily_conversion.php',
          gb: converDisplayValue(
            common.productCodeList,
            newParams['advrtsPrdtCode'],
            newParams['advrtsTpCode']
          ),
          st_date: moment(newParams.sDate).format('YYYY-MM-DD'),
          en_date: moment(newParams.eDate).format('YYYY-MM-DD'),
          intgSeq: rowObj['KWRD_SEQ'],
        });
        return (
          <IconAreaWrap
            text={rowObj['ORDER_CNT']}
            icon={'faExternalLink'}
            toolTipTitle={t('해당 키워드의 컨버전 리스트')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
    };
    setCustomized(newCustomized);
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
      handleCustom(initParams);
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
      handleCustom(newParams);
    }
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
          useDisplayFilter={true}
          usePltfomTpCodeFilter={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={KeywordStatistics}
        customized={customized}
        useTotal={false}
        excelItemsRemoval="ADVER_IDS"
      />
    </>
  );
};
export default withRouter(Statistics);
